import { Typography } from '@euler/app/components/typography';
import { StatusColors } from '@euler/components/Colors';
import { Icon } from '@euler/components/Icomoon';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { FC, memo } from 'react';
import { TouchableOpacity, TouchableOpacityProps } from 'react-native';

export const AddProductButton: FC<TouchableOpacityProps & { title?: string }> =
  memo(({ title = '推荐产品', ...props }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TouchableOpacity
        css={`
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          background-color: ${StatusColors.Info};
          padding: 0 ${rpx(8)}px 0 ${rpx(6)}px;
          border-radius: ${rpx(20)}px;
          height: ${rpx(21)}px;
        `}
        {...props}
      >
        <Icon name="plus-circle" color={'white'} size={rpx(14)} />
        <Typography.Label
          medium
          size={rpx(11)}
          color={'white'}
          lineHeight={rpx(21)}
          numberOfLines={1}
          css={`
            margin-left: ${rpx(3)}px;
          `}
        >
          {title}
        </Typography.Label>
      </TouchableOpacity>
    );
  });
